import { cn } from "@/app/utils/cn"
import { ArrowLeftIcon } from "lucide-react"

interface CreditCardProps {
  className?: string
  children: React.ReactNode
  hasBackButton?: boolean
  classNameBackButton?: string
  clickBackButton?: () => void
}

export const CreditCard = ({ className, children, hasBackButton = false, classNameBackButton, clickBackButton }: CreditCardProps) => {
  return (
    <div className={cn("bg-white border text-center items-center justify-center border-gray02 rounded-xl flex flex-col px-6 py-4 sm:py-6 md:py-8 w-full relative dark:bg-gray-900 dark:border-gray-700 dark:text-white", className)}>
      {hasBackButton && (
        <div
          className={cn("absolute top-[18px] md:top-9 left-5 md:left-6 cursor-pointer", classNameBackButton)}
          onClick={clickBackButton}
        >
          <ArrowLeftIcon className="w-5 h-5" />
        </div>
      )}
      {children}
    </div>
  )
}